import "./Algo_defination.css";
import { useState, useEffect, useMemo } from "react";

const operators = ["==", "!=", ">", ">=", "<", "<="];

/* =========================================================
   CONDITION FACTORY
========================================================= */

const createCondition = (connector = null) => ({
  id: Date.now() + Math.random(),
  connector,
  left: "",
  operator: "==",
  rightType: "column",
  right: "",
});

export default function Algo_defination({ setActivePage, onClose, onCreate }) {
  const [algorithmName, setAlgorithmName] = useState("");
  const [description, setDescription] = useState("");

  const [previewData, setPreviewData] = useState([]);
  console.log("preview_data_is", previewData);

  const [conditions, setConditions] = useState([createCondition()]);
  console.log("conditions-are", conditions);

  const columns = previewData.length > 0 ? Object.keys(previewData[0]) : [];
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";

  /* =========================================================
     FETCH PREVIEW DATA ONCE
  ========================================================= */

  useEffect(() => {
    const fetchPreviewData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/algorithm/preview_data`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch preview data");
        }

        const data = await response.json();

        setPreviewData(
          Array.isArray(data.preview_data) ? data.preview_data : []
        );
      } catch (error) {
        console.error("Preview data error:", error);

        setPreviewData([]);
      }
    };

    fetchPreviewData();
  }, []);

  const convertValue = (value) => {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === "number") {
      return value;
    }

    if (typeof value === "boolean") {
      return value;
    }

    const stringValue = String(value).trim();

    if (stringValue === "") {
      return "";
    }

    /*
     * Convert numeric strings to numbers.
     *
     * Example:
     *
     * "100"  -> 100
     * "71.5" -> 71.5
     */

    const numericValue = Number(stringValue);

    if (!Number.isNaN(numericValue)) {
      return numericValue;
    }

    return stringValue;
  };

  // addd this
  const isScore = (value) => {
    return typeof value === "string" && /^\d+:\d+$/.test(value.trim());
  };

  const compareScores = (left, right, operator) => {
    const [leftHome, leftAway] = left.trim().split(":").map(Number);
    const [rightHome, rightAway] = right.trim().split(":").map(Number);

    switch (operator) {
      case "==":
        return leftHome === rightHome && leftAway === rightAway;

      case "!=":
        return leftHome !== rightHome || leftAway !== rightAway;

      default:
        return false;
    }
  };
  /* =========================================================
     APPLY SINGLE OPERATOR
  ========================================================= */

  const evaluateCondition = (row, condition) => {
    if (!condition.left || !condition.right) {
      return true;
    }

    /* -------------------------------------------------------
       LEFT VALUE
    ------------------------------------------------------- */

    const leftValue = convertValue(row[condition.left]);
    console.log("left_value_is:", leftValue, "| type:", typeof leftValue);

    /* -------------------------------------------------------
       RIGHT VALUE
       
       If rightType is "column", get the value from another
       column.
       
       If rightType is "value", use the value entered by user.
    ------------------------------------------------------- */

    let rightValue;

    if (condition.rightType === "column") {
      rightValue = convertValue(row[condition.right]);
    } else {
      rightValue = convertValue(condition.right);
    }

    console.log("right_value_is:", rightValue, "| type:", typeof rightValue);

    /* -------------------------------------------------------
       If either side doesn't exist, don't crash.
    ------------------------------------------------------- */

    if (leftValue === null || leftValue === undefined) {
      return false;
    }

    if (rightValue === null || rightValue === undefined) {
      return false;
    }
    /* -------------------------------------------------------
     SCORE COMPARISON
  ------------------------------------------------------- */

    if (isScore(leftValue) && isScore(rightValue)) {
      return compareScores(leftValue, rightValue, condition.operator);
    }

    /* =======================================================
       OPERATOR
    ======================================================= */
    const con_operator = condition.operator;
    console.log("condition_operator_is", con_operator);
    switch (condition.operator) {
      case "==":
        return leftValue === rightValue;

      case "!=":
        return leftValue !== rightValue;

      case ">":
        return leftValue > rightValue;

      case ">=":
        return leftValue >= rightValue;

      case "<":
        return leftValue < rightValue;

      case "<=":
        return leftValue <= rightValue;

      default:
        return true;
    }
  };

  /* =========================================================
     FILTER DATA IN REAL TIME
     
     This recalculates whenever:
     
     - previewData changes
     - conditions change
     
     No second API request is made.
  ========================================================= */

  const filteredPreviewData = useMemo(() => {
    if (!previewData.length) {
      return [];
    }

    const activeConditions = conditions.filter(
      (condition) =>
        condition.left && condition.operator && condition.right !== ""
    );
    console.log("active_condition_is", activeConditions);

    if (activeConditions.length === 0) {
      return previewData;
    }

    /* =======================================================
       FILTER EACH ROW
    ======================================================= */

    return previewData.filter((row) => {
      /*
       * Evaluate first condition.
       */

      let result = evaluateCondition(row, activeConditions[0]);
      console.log("first_result is", result);

      /*
       * Evaluate remaining conditions using their connector.
       */

      for (let i = 1; i < activeConditions.length; i++) {
        const condition = activeConditions[i];

        const conditionResult = evaluateCondition(row, condition);

        if (condition.connector === "AND") {
          result = result && conditionResult;
        } else if (condition.connector === "OR") {
          result = result || conditionResult;
        }
      }
      console.log("second_result is", result);

      return result;
    });
  }, [previewData, conditions]);

  /* =========================================================
     ADD CONDITION
  ========================================================= */

  const addCondition = () => {
    setConditions((prev) => [...prev, createCondition("AND")]);
  };

  /* =========================================================
     REMOVE CONDITION
  ========================================================= */

  const removeCondition = (id) => {
    if (conditions.length === 1) {
      return;
    }

    setConditions((prev) => prev.filter((condition) => condition.id !== id));
  };

  /* =========================================================
     UPDATE CONDITION
  ========================================================= */

  const updateCondition = (id, field, value) => {
    setConditions((prev) =>
      prev.map((condition) =>
        condition.id === id
          ? {
              ...condition,
              [field]: value,
            }
          : condition
      )
    );
  };

  /* =========================================================
     CHANGE RIGHT TYPE
  ========================================================= */

  const changeRightType = (id, value) => {
    setConditions((prev) =>
      prev.map((condition) =>
        condition.id === id
          ? {
              ...condition,
              rightType: value,
              right: "",
            }
          : condition
      )
    );
  };

  /* =========================================================
     CREATE ALGORITHM
  ========================================================= */

  const createAlgorithm = async () => {
    if (!algorithmName.trim()) {
      alert("Please enter an algorithm name.");
      return;
    }

    /* =========================================================
     BUILD JSON PAYLOAD
  ========================================================= */

    const algorithmPayload = {
      name: algorithmName.trim(),

      description: description.trim(),
      prediction: prediction,

      logic: {
        conditions: conditions.map(({ id, ...condition }) => ({
          connector: condition.connector,
          left: condition.left,
          operator: condition.operator,
          rightType: condition.rightType,
          right: condition.right,
        })),
      },
    };

    console.log("ALGORITHM PAYLOAD:", algorithmPayload);

    /* =========================================================
     SEND TO FASTAPI
  ========================================================= */

    try {
      const response = await fetch(
        `${API_URL}/algorithm/create`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(algorithmPayload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);

        throw new Error(errorData?.detail || "Failed to create algorithm");
      }

      const result = await response.json();

      console.log("ALGORITHM CREATED:", result);

      alert("Algorithm created successfully.");

      /* Optional */
      onCreate?.(result);
    } catch (error) {
      console.error("Create algorithm error:", error);

      alert(`Failed to create algorithm: ${error.message}`);
    }
  };
  /* =========================================================
     RENDER
  ========================================================= */
  const PREDICTION_OPTIONS = [
    { value: "UNDER_1_5", label: "Under 1.5" },
    { value: "UNDER_2_5", label: "Under 2.5" },
    { value: "UNDER_3_5", label: "Under 3.5" },
    { value: "OVER_1_5", label: "Over 1.5" },
    { value: "OVER_2_5", label: "Over 2.5" },
    { value: "OVER_3_5", label: "Over 3.5" },
    { value: "GG", label: "GG" },
    { value: "NG", label: "NG" },
  ];
  const [prediction, setPrediction] = useState("");
  return (
    <div className="algo_modal_overlay">
      <div className="algo_modal">
        {/* ===================================================
            HEADER
        =================================================== */}

        <div className="algo_modal_header">
          <div>
            <h2>Create Algorithm</h2>

            <p>Define the conditions your algorithm should use.</p>
          </div>

          <button
            className="algo_close_button"
            onClick={() => setActivePage("")}
          >
            ×
          </button>
        </div>

        {/* ===================================================
            BODY
        =================================================== */}

        <div className="algo_modal_body">
          {/* =================================================
              ALGORITHM DETAILS
          ================================================= */}

          <section className="algo_section algo_details_section">
            <div className="algo_section_header">
              <div>
                <h3>Algorithm Details</h3>

                <span>Give your algorithm a name and description.</span>
              </div>
            </div>

            <div className="algo_details_grid">
              {/* NAME */}
              <div className="algo_field">
                <label>Algorithm Name</label>

                <input
                  className="algo_name_input"
                  value={algorithmName}
                  onChange={(e) => setAlgorithmName(e.target.value)}
                  placeholder="e.g. Home Advantage"
                />
              </div>

              {/* PREDICTION */}
              <div className="algo_field">
                <label>Prediction</label>

                <select
                  className="algo_prediction_input"
                  value={prediction}
                  onChange={(e) => setPrediction(e.target.value)}
                >
                  <option value="">Select prediction</option>

                  {PREDICTION_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* DESCRIPTION */}
              <div className="algo_field">
                <label>Description</label>

                <textarea
                  className="algo_description_input"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Describe what this algorithm is intended to identify..."
                  rows={3}
                />
              </div>
            </div>
          </section>

          {/* =================================================
              LOGIC BUILDER
          ================================================= */}

          <section className="algo_section logic_definations">
            <div className="algo_section_header">
              <div>
                <h3>Logic Builder</h3>

                <span>Define the conditions that must be satisfied.</span>
              </div>
            </div>

            <div className="conditions_container">
              {conditions.map((condition, index) => (
                <div className="condition_wrapper" key={condition.id}>
                  {/* CONNECTOR */}

                  {index > 0 && (
                    <div className="connector_container">
                      <div className="connector_line"></div>

                      <select
                        className="connector_select"
                        value={condition.connector}
                        onChange={(e) =>
                          updateCondition(
                            condition.id,
                            "connector",
                            e.target.value
                          )
                        }
                      >
                        <option value="AND">AND</option>

                        <option value="OR">OR</option>
                      </select>

                      <div className="connector_line"></div>
                    </div>
                  )}

                  {/* CONDITION CARD */}

                  <div className="condition_card">
                    <div className="condition_number">{index + 1}</div>

                    <div className="condition_content">
                      {/* LEFT COLUMN */}

                      <div className="condition_field">
                        <label>Column</label>

                        <select
                          value={condition.left}
                          onChange={(e) =>
                            updateCondition(
                              condition.id,
                              "left",
                              e.target.value
                            )
                          }
                        >
                          <option value="">Select column</option>

                          {columns.map((column) => (
                            <option key={column} value={column}>
                              {column}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* OPERATOR */}

                      <div className="condition_field operator_field">
                        <label>Operator</label>

                        <select
                          value={condition.operator}
                          onChange={(e) =>
                            updateCondition(
                              condition.id,
                              "operator",
                              e.target.value
                            )
                          }
                        >
                          {operators.map((operator) => (
                            <option key={operator} value={operator}>
                              {operator}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* COMPARE TYPE */}

                      <div className="condition_field">
                        <label>Compare With</label>

                        <select
                          value={condition.rightType}
                          onChange={(e) =>
                            changeRightType(condition.id, e.target.value)
                          }
                        >
                          <option value="column">Column</option>

                          <option value="value">Value</option>
                        </select>
                      </div>

                      {/* RIGHT VALUE */}

                      <div className="condition_field right_value_field">
                        <label>
                          {condition.rightType === "column"
                            ? "Column"
                            : "Value"}
                        </label>

                        {condition.rightType === "column" ? (
                          <select
                            value={condition.right}
                            onChange={(e) =>
                              updateCondition(
                                condition.id,
                                "right",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select column</option>

                            {columns.map((column) => (
                              <option key={column} value={column}>
                                {column}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            value={condition.right}
                            onChange={(e) =>
                              updateCondition(
                                condition.id,
                                "right",
                                e.target.value
                              )
                            }
                            placeholder="Enter value"
                          />
                        )}
                      </div>

                      {/* REMOVE */}

                      <button
                        className="remove_condition"
                        onClick={() => removeCondition(condition.id)}
                        disabled={conditions.length === 1}
                        title="Remove condition"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* ADD CONDITION */}

            <button className="add_condition_button" onClick={addCondition}>
              <span>+</span>
              Add Condition
            </button>
          </section>

          {/* =================================================
              DATA PREVIEW
          ================================================= */}

          <section className="algo_section">
            <div className="algo_section_header preview_header">
              <div>
                <h3>Data Preview</h3>

                <span>Preview the data your algorithm will work with.</span>
              </div>

              <div className="preview_count">
                {filteredPreviewData.length}
                {" / "}
                {previewData.length}
                {" rows"}
              </div>
            </div>

            <div className="preview_table_container">
              <table className="preview_table">
                <thead>
                  <tr>
                    {columns.map((column) => (
                      <th key={column}>{column}</th>
                    ))}

                    <th>Result</th>
                  </tr>
                </thead>

                <tbody>
                  {/* {filteredPreviewData.map((row, index) => (
                    
                    <tr key={row.id ?? index}>
                      {columns.map((column) => (
                        <td key={column}>{row[column] ?? "-"}</td>
                      ))}

                      <td>
                        <span className="result_pending">✓</span>
                      </td>
                    </tr>
                  ))} */}

                  {/* NO RESULTS */}

                  {/* {filteredPreviewData.length === 0 &&
                    previewData.length > 0 && (
                      <tr>
                        <td colSpan={columns.length + 1}>
                          No rows match the current conditions.
                        </td>
                      </tr>
                    )} */}
                  {filteredPreviewData.map((row2, index) => {
                    console.log("RENDERING ROW:", index, row2);

                    return (
                      <tr key={row2.Team_code}>
                        {columns.map((column) => (
                          <td key={column}>{row2[column] ?? "-"}</td>
                        ))}

                        <td>
                          <span className="result_pending">✓</span>
                        </td>
                      </tr>
                    );
                  })}
                  {filteredPreviewData.length === 0 &&
                    previewData.length > 0 && (
                      <tr>
                        <td colSpan={columns.length + 1}>
                          No rows match the current conditions.
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </div>
          </section>
        </div>

        {/* ===================================================
            FOOTER
        =================================================== */}

        <div className="algo_modal_footer">
          <button className="cancel_button" onClick={onClose}>
            Cancel
          </button>

          <button className="create_algorithm_button" onClick={createAlgorithm}>
            Create Algorithm
          </button>
        </div>
      </div>
    </div>
  );
}
